import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';

//material ui components:
import { withStyles } from '@material-ui/core/styles';
import { Paper, Grid, Typography, TextField } from '@material-ui/core';
import { Tooltip, Fade } from '@material-ui/core';

//actions:
import { modifyFieldOtrosDatos } from '../../../actions/cierre_diario_actions';
import {  setSaveState } from '../../../actions';

//components:
import IntNumberFormatInput from '../../../components/int_number_input_formatter';
import FloatNumberFormatInput from '../../../components/float_number_input_formatter';

//styles:
const styles = theme => ({
    container: {
        padding: 0,
        fontSize: 13,
        fontWeight: '600',
        margin: '0 8px',
        borderBottom: '3px solid #b8b8b8',
        borderRight: '3px solid #b8b8b8',
        height: 155,
    },
    paperTitle: {
        fontSize: 13,
        fontWeight: '500',
        color: 'white',
        margin: 0,
        backgroundColor: theme.palette.primary.main,
        padding: '4px 2px 4px 12px',
    },
    containerItems: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        height: 130,
    },
    singleItem: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '2px 15px',
    },
    center: {
        display: 'flex',
        alignContent: 'center',
        marginTop: 6,
    },
    label: {
        maxWidth: 85,
        fontSize: 11,
    },
    input: {
        width: 60,
        [`& fieldset`]: {
            borderRadius: 0,
            borderColor: 'black !important'
        },
    },
    inputImporte: {
        textAlign: 'right',
        margin: '8px 8px 8px 2px',
        padding: 0,
        fontSize: 12,
    },
    inputlarge: {
        margin: '0 auto',
        width: '90%',
        height: 35,
        [`& fieldset`]: {
            borderRadius: 0,
            borderColor: 'black !important',
            height: 'inherit',
        },
    },
    barArcadeContainer: {
        height: 'inherit',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between'
    },
    paperHalf: {
        height: '49%',
        margin: 0,
        borderBottom: '3px solid #b8b8b8',
        borderRight: '3px solid #b8b8b8',
    },
    tooltip: {
        fontSize: 14,
        color: "white",
        backgroundColor: '#3a3434',
        fontWeight: 200,
    },
});

class FirstRowPapers extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            //bolera:
            interPista: !this.props.otrosDatosCierreDiario.interPista ? 0 : this.props.otrosDatosCierreDiario.interPista,
            pistasParadas: !this.props.otrosDatosCierreDiario.pistasParadas ? 0 : this.props.otrosDatosCierreDiario.pistasParadas,
            paresZapatos: !this.props.otrosDatosCierreDiario.paresZapatos ? 0 : this.props.otrosDatosCierreDiario.paresZapatos,
            //venta normal/bar:
            ventasNormalBar: !this.props.otrosDatosCierreDiario.ventasNormalBar ? 0 : this.props.otrosDatosCierreDiario.ventasNormalBar,
            //maq arcade paradas:
            maqArcadeParadas: !this.props.otrosDatosCierreDiario.maqArcadeParadas ? 0 : this.props.otrosDatosCierreDiario.maqArcadeParadas,
            //kids:
            numNinos: !this.props.otrosDatosCierreDiario.numNinos ? 0 : this.props.otrosDatosCierreDiario.numNinos,
            numAniversarios: !this.props.otrosDatosCierreDiario.numAniversarios ? 0 : this.props.otrosDatosCierreDiario.numAniversarios,
            ninosKids: !this.props.otrosDatosCierreDiario.ninosKids ? 0 : this.props.otrosDatosCierreDiario.ninosKids,
        };
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        //once we get the data:
        if (prevProps.otrosDatosCierreDiario !== this.props.otrosDatosCierreDiario) {
            this.setState({
                //bolera:
                interPista: !this.props.otrosDatosCierreDiario.interPista ? 0 : this.props.otrosDatosCierreDiario.interPista,
                pistasParadas: !this.props.otrosDatosCierreDiario.pistasParadas ? 0 : this.props.otrosDatosCierreDiario.pistasParadas,
                paresZapatos: !this.props.otrosDatosCierreDiario.paresZapatos ? 0 : this.props.otrosDatosCierreDiario.paresZapatos,
                //venta normal/bar:
                ventasNormalBar: !this.props.otrosDatosCierreDiario.ventasNormalBar ? 0 : this.props.otrosDatosCierreDiario.ventasNormalBar,
                //maq arcade paradas:
                maqArcadeParadas: !this.props.otrosDatosCierreDiario.maqArcadeParadas ? 0 : this.props.otrosDatosCierreDiario.maqArcadeParadas,
                //kids:
                numNinos: !this.props.otrosDatosCierreDiario.numNinos ? 0 : this.props.otrosDatosCierreDiario.numNinos,
                numAniversarios: !this.props.otrosDatosCierreDiario.numAniversarios ? 0 : this.props.otrosDatosCierreDiario.numAniversarios,
                ninosKids: !this.props.otrosDatosCierreDiario.ninosKids ? 0 : this.props.otrosDatosCierreDiario.ninosKids,
            });
        };
    };


    handleValueChange = (event, field) => {

        this.setState({ ...this.state, [field]: event.target.value });
    };


    onBlur = (event, field) => {

        this.props.setSaveState(true);
        this.props.modifyFieldOtrosDatos(field, this.state[field]);
    };

    render() {

        const { classes } = this.props;

        return (

            <Grid container style={{ marginBottom: 5, height: 155 }}>
                {/* first row*/}

                <Grid item xs={4} >
                    {/* bolera */}
                    <Paper className={classes.container} elevation={0}>
                        {/* title*/}
                        <h5 className={classes.paperTitle}>Bolera</h5>

                        <div className={classes.containerItems}>
                            <div className={classes.singleItem} >
                                {/* first label and input*/}
                                <Typography variant="subtitle2" className={classes.label}>Intervenciones en Pista</Typography>

                                <TextField
                                    className={classes.input}
                                    InputProps={{ classes: { input: classes.inputImporte }, inputComponent: IntNumberFormatInput }}
                                    disabled={this.props.isDiaCerrado ? true : false}
                                    fullWidth
                                    // placeholder={'0'}
                                    id={'interPista'}
                                    value={this.state.interPista}
                                    onChange={(event) => this.handleValueChange(event, 'interPista')}
                                    onBlur={(event) => this.onBlur(event, 'interPista')}
                                    variant='outlined'
                                />
                            </div>

                            <div className={classes.singleItem} >
                                {/* second label and input*/}
                                <Typography variant="subtitle2" className={classes.label}>Pistas paradas</Typography>


                                <TextField
                                    disabled={this.props.isDiaCerrado ? true : false}
                                    fullWidth
                                    // placeholder={'0'}
                                    className={classes.input}
                                    id={'pistasParadas'}
                                    InputProps={{ classes: { input: classes.inputImporte }, inputComponent: IntNumberFormatInput }}
                                    value={this.state.pistasParadas}
                                    onChange={(event) => this.handleValueChange(event, 'pistasParadas')}
                                    onBlur={(event) => this.onBlur(event, 'pistasParadas')}
                                    variant='outlined'
                                />
                            </div>


                            <div className={classes.singleItem} >
                                {/* third label and input*/}
                                <Typography variant="subtitle2" className={classes.label}>Pares de Zapatos</Typography>


                                <TextField
                                    disabled={this.props.isDiaCerrado ? true : false}
                                    fullWidth
                                    // placeholder={'0'}
                                    className={classes.input}
                                    id={'paresZapatos'}
                                    InputProps={{ classes: { input: classes.inputImporte }, inputComponent: IntNumberFormatInput }}
                                    value={this.state.paresZapatos}
                                    onChange={(event) => this.handleValueChange(event, 'paresZapatos')}
                                    onBlur={(event) => this.onBlur(event, 'paresZapatos')}
                                    variant='outlined'
                                />
                            </div>
                        </div>

                    </Paper>
                </Grid>

                {/* bar y arcade: */}
                <Grid item xs={4} className={classes.barArcadeContainer}>
                    {/* cuadro bar */}
                    <Paper elevation={0} className={classes.paperHalf}>
                        <h5 className={classes.paperTitle}>Venta Normal/Bar %</h5>
                        <div className={`${classes.singleItem} ${classes.center}`}>
                            <Tooltip title="Valor calculado" TransitionComponent={Fade} TransitionProps={{ timeout: 600 }} placement="top-end" classes={{tooltip: this.props.classes.tooltip}}>
                                <TextField
                                    disabled
                                    fullWidth
                                    // placeholder={'0'}
                                    className={classes.inputlarge}
                                    id={'ventasNormalBar'}
                                    InputProps={{ classes: { input: classes.inputImporte }, inputComponent: FloatNumberFormatInput }}
                                    value={this.state.ventasNormalBar}
                                    onChange={(event) => this.handleValueChange(event, 'ventasNormalBar')}
                                    onBlur={(event) => this.onBlur(event, 'ventasNormalBar')}
                                    variant='outlined'
                                />
                            </Tooltip>
                        </div>
                    </Paper>

                    {/* cuadro arcade */}
                    <Paper className={classes.paperHalf} elevation={0}>
                        <h5 className={classes.paperTitle}>Maq.Arcade parada</h5>
                        <div className={`${classes.singleItem} ${classes.center}`}>
                            <TextField
                                disabled={this.props.isDiaCerrado ? true : false}
                                fullWidth
                                // placeholder={'0'}
                                className={classes.inputlarge}
                                id={'maqArcadeParadas'}
                                InputProps={{ classes: { input: classes.inputImporte }, inputComponent: IntNumberFormatInput }}
                                value={this.state.maqArcadeParadas}
                                onChange={(event) => this.handleValueChange(event, 'maqArcadeParadas')}
                                onBlur={(event) => this.onBlur(event, 'maqArcadeParadas')}
                                variant='outlined'
                            />
                        </div>
                    </Paper>

                </Grid>

                <Grid item xs={4}  >
                    {/* kids */}
                    <Paper className={classes.container} elevation={0}>
                        <h5 className={classes.paperTitle}>KIDS</h5>
                        <div className={classes.containerItems}>
                            <div className={classes.singleItem} >
                                {/* first label and input*/}
                                <Typography variant="subtitle2" className={classes.label}>Nº Niños/Cumples</Typography>

                                <TextField
                                    disabled={this.props.isDiaCerrado ? true : false}
                                    fullWidth
                                    // placeholder={'0'}
                                    className={classes.input}
                                    id={'numNinos'}
                                    InputProps={{ classes: { input: classes.inputImporte }, inputComponent: IntNumberFormatInput }}
                                    value={this.state.numNinos}
                                    onChange={(event) => this.handleValueChange(event, 'numNinos')}
                                    onBlur={(event) => this.onBlur(event, 'numNinos')}
                                    variant='outlined'
                                />
                            </div>

                            <div className={classes.singleItem} >
                                {/* second label and input*/}
                                <Typography variant="subtitle2" className={classes.label}>Nº Cumpleaños</Typography>

                                <TextField
                                    disabled={this.props.isDiaCerrado ? true : false}
                                    fullWidth
                                    // placeholder={'0'}
                                    className={classes.input}
                                    id={'numAniversarios'}
                                    InputProps={{ classes: { input: classes.inputImporte }, inputComponent: IntNumberFormatInput }}
                                    value={this.state.numAniversarios}
                                    onChange={(event) => this.handleValueChange(event, 'numAniversarios')}
                                    onBlur={(event) => this.onBlur(event, 'numAniversarios')}
                                    variant='outlined'
                                />
                            </div>


                            <div className={classes.singleItem}  >
                                {/* third label and input*/}
                                <Typography variant="subtitle2" className={classes.label}>Niños en Kids</Typography>

                                <TextField
                                    disabled={this.props.isDiaCerrado ? true : false}
                                    fullWidth
                                    // placeholder={'0'}
                                    className={classes.input}
                                    id={'ninosKids'}
                                    InputProps={{ classes: { input: classes.inputImporte }, inputComponent: IntNumberFormatInput }}
                                    value={this.state.ninosKids}
                                    onChange={(event) => this.handleValueChange(event, 'ninosKids')}
                                    onBlur={(event) => this.onBlur(event, 'ninosKids')}
                                    variant='outlined'
                                />
                            </div>
                        </div>
                    </Paper>
                </Grid>

            </Grid>
        );
    };
};

FirstRowPapers.propTypes = {
    otrosDatosCierreDiario: PropTypes.object.isRequired,
    modifyFieldOtrosDatos: PropTypes.func.isRequired,
    isDiaCerrado: PropTypes.bool.isRequired,
};


function mapStateToProps(state) {
    return {
        otrosDatosCierreDiario: state.otrosDatosCierreDiario.datos,
        isDiaCerrado: state.centroDiaSelected.isDiaCerrado,
    };
};

function mapDispathToProps(dispatch) {
    return bindActionCreators({
        modifyFieldOtrosDatos,
        setSaveState
    }, dispatch);
};

export default connect(
    mapStateToProps,
    mapDispathToProps
)(withStyles(styles, { withTheme: true })(FirstRowPapers));
